export default "__VITE_ASSET__C9Cysoi5__"